import { Grid, TableCell, TableRow, Typography } from '@mui/material';
import React from 'react';
import CodeQrComponent from '../../../usuario/usu_entidades/components/code_qr';

const ExpandedSeccionesComponent = ({ data, rowData }) => {
  return (
    <TableRow>
      <TableCell colSpan={rowData.length} sx={{ p: 2 }}>
        <Grid container>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
            }}
          >
            <Typography variant="body1" color="initial" sx={{ m: 2 }}>
              <strong>Descripción: </strong>
              {data.desc || '--'}
            </Typography>
            <CodeQrComponent
              size={150}
              maxWidth={150}
              value={`${data.codeqr}`}
            />
          </Grid>
          <Grid item xs={12} md={3} align="center">
            <strong>Fecha de creación</strong>
            <br />
            {data.createdAt}
          </Grid>
          <Grid item xs={12} md={3} align="center">
            <strong>Fecha de edición</strong>
            <br />
            {data.updatedAt}
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default ExpandedSeccionesComponent;
